import { render, staticRenderFns } from "./PageJetton.vue?vue&type=template&id=753923ee"
import script from "./PageJetton.vue?vue&type=script&lang=js"
export * from "./PageJetton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports